define('ContactUsForm.ei1.Main', [
    'Contact.ei1.Main.View'
], function (
    ContactMainView
) {
    'use strict';

    return {
        mountToApp: function (container) {
            var PageType = container.getComponent('PageType');

            PageType.registerPageType({
                name: 'contact_us_page.tpl',
                routes: ['contact-us'],
                view: ContactMainView,
                defaultTemplate: {
                    name: 'contact_us_page.tpl',
                    displayName: 'Contact Us'
                }
            });
        }
    };
});
